module.exports = __webpack_public_path__ + "static/media/GlaucoLima_Soundtrack_Portfolio_1.f2a826a2.mp3";